import '../../css/glide.css'
import Glide from '@glidejs/glide';

export const create = (selector, options = {
    type: 'carousel'
}) => new Glide(selector, options);